import { createSentryCallback } from "@saflib/vendors-sentry-client";
import { initPostHogIfConfigured } from "@saflib/vendors-posthog-client/init";

export const sentryCallback = createSentryCallback({ source: "power-up" });

/** Call once from each SPA / static-site entry before mounting. */
export function initClientObservability(): void {
  initPostHogIfConfigured();
}
